import { TSearchResult } from "../../../components/elements/search-components/search-results/search-results";
import { getSearchHitTextFromFullText } from "../../../helpers/search-helper";

export const postSearchTermMapper = (result: any, searchTerm: string): Array<TSearchResult> | undefined => {
  const mappedItems = result?.map((item: any): TSearchResult => {
    return {
      title: item?.Name,
      url: item?.RelativePath,
      text: getSearchHitTextFromFullText(item?._fulltext, searchTerm),
    };
  });

  return mappedItems;
};
